import request from "@/utils/request"

// 获取所有专辑
export function getAlbumList(){
    return request({
        method:'get',
        url:'/album'
    })
}
